import React, {Component} from "react";
import PostList from "./PostList/index";
import { postList, user} from "./data";
import IntlMessages from 'util/IntlMessages';

class Wall extends Component {

  render() {
    return (
      <div 
      // style={{height:"calc(100% - 40px)"}}
      // className="jr-main-content jr-card" style={{padding:"8px",paddingBottom:"10px"}}
      
      >
          {/* <div className="text-center">
              <h1 style={{ paddingTop: '12px',color:"#000" }}><IntlMessages id="Errand.Flow.Comment"/></h1>
          </div> */}
        <div className="d-flex justify-content-center row" 
          >
          <div 
          // className="col-11"
          className="col-sm-12 col-lg-11"
          >
              <div
              style={{
                
            //height:"calc(100vh - 262px)",
            height:"calc(100vh - 208px)",
              //   height: '100%', 
              // minHeight: 700
            }}
              //  className="jr-wall-postlist" 
               >
                <PostList postList={postList} user={user}/>
              </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Wall;
